import hljs from "highlight.js"

export default class Code {
  constructor() {
    const codeBlocks = document.querySelectorAll("pre code")

    codeBlocks.forEach((block) => {
      // eslint-disable-next-line no-undef
      hljs.highlightElement(block)
    })
  }
}
